import { render, staticRenderFns } from "./index-tab.vue?vue&type=template&id=3ac7954d&scoped=true"
import script from "./index-tab.vue?vue&type=script&lang=js"
export * from "./index-tab.vue?vue&type=script&lang=js"
import style0 from "./index-tab.vue?vue&type=style&index=0&id=3ac7954d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7954d",
  null
  
)

export default component.exports